import React from 'react'

import { Box, Stack } from '@mui/material'

import { Skeleton } from '@repo/ui'

/**
 * Placeholder for the prose column while its chunk loads.
 *
 * Worth being precise about what is and is not loading here, because a skeleton that
 * stands in for nothing is just decoration. The section nav, the page title, and the
 * table of contents all come from the manifest, which is part of the main bundle — they
 * are on screen immediately and never flash a placeholder. The markdown renderer is the
 * only late arrival: it is code-split, so the reader can wait a moment for it on a slow
 * connection. So exactly one region gets a skeleton, and it mirrors that region — a
 * heading bar, a paragraph block, a list, another heading — at the prose column's own
 * width, so nothing shifts when the real text replaces it (§19).
 */
export const DocProseSkeleton = () => (
  <Box>
    <Skeleton width="45%" height={22} sx={{ mb: 5 }} />
    <Skeleton lines={4} height={13} sx={{ mb: 8 }} />
    <Skeleton width="35%" height={22} sx={{ mb: 5 }} />
    <Skeleton lines={3} height={13} sx={{ mb: 8 }} />
    <Stack spacing={2} sx={{ pl: 4, mb: 8 }}>
      <Skeleton width="80%" height={13} />
      <Skeleton width="72%" height={13} />
      <Skeleton width="86%" height={13} />
    </Stack>
    <Skeleton width="40%" height={22} sx={{ mb: 5 }} />
    <Skeleton lines={3} height={13} />
  </Box>
)
